var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroupUsersIconMembers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.66898 8.16895L2.75737 8.25734L2.66898 8.16896C1.51229 9.32567 0.875 10.8642 0.875 12.5V12.625H1H1.9375H2.0625V12.5C2.0625 9.77756 4.27756 7.5625 7 7.5625C9.72244 7.5625 11.9375 9.77756 11.9375 12.5V12.625H12.0625H13H13.125V12.5C13.125 10.8642 12.4877 9.32567 11.331 8.16896L11.2427 8.25734L11.331 8.16895C10.7211 7.55901 10.0047 7.09369 9.22363 6.78987C10.0572 6.13146 10.5938 5.11178 10.5938 3.96875C10.5938 1.98705 8.9817 0.375 7 0.375C5.0183 0.375 3.40625 1.98705 3.40625 3.96875C3.40625 5.11178 3.94277 6.13147 4.77638 6.78987C3.99536 7.09369 3.27894 7.55901 2.66898 8.16895ZM7 6.375C5.67331 6.375 4.59375 5.29546 4.59375 3.96875C4.59375 2.64204 5.67331 1.5625 7 1.5625C8.32669 1.5625 9.40625 2.64204 9.40625 3.96875C9.40625 5.29546 8.32669 6.375 7 6.375Z",
    fill: "#363B4D",
    stroke: "#363B4D",
    strokeWidth: 0.25
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupUsersIconMembers);
export default __webpack_public_path__ + "static/media/GroupUsersIconMembers.49a15b022a26a036b6ba978d223757a3.svg";
export { ForwardRef as ReactComponent };